import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer3Nawodnienie from "../../components/offer/3nawodnienie";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Systemy nawadniania ogrodów i trawników | Gdańsk, Gdynia, Wejherowo, Kaszuby</title>
        <meta name="title" content="Systemy nawadniania ogrodów i trawników | Gdańsk, Gdynia, Wejherowo, Kaszuby" />
        <meta
          name="description"
          content="Projektowanie i montaż automatycznych systemów nawadniania dla ogrodów i trawników. Oszczędzaj wodę i czas w Gdańsku, Gdyni, Kartuzach, Wejherowie i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Systemy nawadniania ogrodów i trawników | Gdańsk, Gdynia, Wejherowo, Kaszuby"
        />
        <meta
          property="og:description"
          content="Projektowanie i montaż automatycznych systemów nawadniania dla ogrodów i trawników. Oszczędzaj wodę i czas w Gdańsku, Gdyni, Kartuzach, Wejherowie i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer3Nawodnienie />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
